module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/ramda/src/internal/_isObject.js
 ** module id = 154
 ** module chunks = 0
 **/